<template>
  <div ref="staffIndex">
    <div class="box">
      <section class="select" style="minwidth: 800px">
      <div class="top">
        <span
          :class="{ god: item.value === block ? true : false }"
          v-for="item in tops"
          :key="item.value"
          @click="all(item.value)"
          >{{ item.name }}</span
        >
      </div>
      </section>
      <div  class="mind">
        <div class="mind-one">
          <div class="mind-one-top" v-if="block === 1" >
            <span style="padding-left:20px">
              <Input
                v-model.trim="code"
                placeholder="订单编号"
                style="width: 280px; height: 30px"
              ></Input
            ></span>
            <span>
              <Input
                v-model.trim="partMsg"
                placeholder="配件编码/配件名称"
                style="width: 270px; height: 30px; margin: 0 20px"
              ></Input
            ></span>
            <span>
              <Select
                v-model="userNames"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 250px; height: 30px; position: relative"
                placeholder="店铺名称"
                :loading="remoteloading"
                @on-change="getOnes"
              >
                <Option
                  v-for="item in company"
                  :value="item.shopId"
                  :key="item.shopId"
                  >{{ item.shopName }}</Option
                >
              </Select>
            </span>
            <span style="margin-left: 20px">
              <Date-picker
                type="daterange"
                placement="bottom-end"
                placeholder="选择下单日期"
                style="width: 300px"
                format="yyyy-MM-dd"
                class="w160"
                v-model="value3"
                @on-change="changeCompanyDate"
                clearable
              ></Date-picker
            ></span>
             <span style="width:200px"></span>
             <Button @click="reset" class="search reset" v-has="'WSS-2001-search'">重置</Button>
             <Button @click="search" class="search" v-has="'WSS-2001-search'">查询</Button>
            <span style="margin-left: 20px">
              <Select
               placeholder="订单状态"
               filterable 
                v-model="model1"
                style="width: 280px; height: 30px;  position: relative"
                @on-change="statusSelection"
              >
                <Option
                  v-for="item in orderStatus"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select></span
            >
            <span style="margin-left: 20px">
              <Select
               placeholder="订单来源"
               filterable 
                v-model="model2"
                style="width: 270px; height: 30px;  position: relative"
                @on-change="sourceSelection"
              >
                <Option
                  v-for="item in orderSource"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select></span
            >

          </div>
          <div class="mind-one-top" v-if="block === 6" >
            <span>
              <Input
                v-model.trim="salesfrom.code"
                placeholder="订单编号"
                style="width: 160px; height: 30px;padding-left:20px"
              ></Input
            ></span>
            <span>
              <Input
                v-model.trim="salesfrom.partMsg"
                placeholder="配件编码/配件名称"
                style="width: 160px; height: 30px; margin: 0 10px"
              ></Input
            ></span>
            <span>
              <Select
                v-model="salesfrom.userNames"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 160px; height: 30px;position: relative"
                placeholder="店铺名称"
                :loading="remoteloading"
                @on-change="getOnes6"
              >
                <Option
                  v-for="item in companytk"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.tenantShortName }}</Option
                >
              </Select>
            </span>
             <span style="margin-left: 20px">
              <Select
                v-model="salesfrom.model1"
                clearable
                style="width: 160px; height: 30px;position: relative"
                placeholder='订单状态'
                @on-change="statusSelectiontk"
              >
                <Option
                  v-for="item in orderStatusth"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select></span
            >
            <Button @click="searchtk" class="search">搜索</Button>
          </div>
          <div class="mind-one-top" v-if="block === 7" >
            <span>
              <Input
                v-model.trim="claim.code"
                placeholder="订单编号"
                style="width: 280px; height: 30px;padding-left:20px"
              ></Input
            ></span>
            <span>
              <Input
                v-model.trim="claim.part"
                placeholder="配件编码/配件名称"
                style="width: 320px; height: 30px; margin: 0 10px"
              ></Input
            ></span>
            <span>
              <Select
                v-model="claim.userNames"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 320px; height: 30px;position: relative"
                placeholder="店铺名称"
                :loading="remoteloading"
                @on-change="getOnes6"
              >
                <Option
                  v-for="item in company"
                  :value="item.shopId"
                  :key="item.shopId"
                  >{{ item.shopName }}</Option
                >
              </Select>
            </span>
            <span>
              <Select
                v-model="claim.state"
                class="w100 mr10"
                clearable
                filterable
                remote
                style="width: 320px; height: 30px;position: relative;padding-left:20px"
                placeholder="理赔单状态"
                @on-change="getOnes6"
              >
                <Option
                  v-for="item in claimstateList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select>
            </span>
            <Button @click="searchtk" class="search">搜索</Button>
          </div>
          <Spin fix v-if="show">
            <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
          <div style="padding-top:20px" class="table">
            <vxe-table
              ref="xTable"
              auto-resize
              :data="tableData"
              class="mytable-style"
              style="margin-top:20px"
              :cell-style="cellStyle"
              :span-method="colspanMethod1"
              align="center"
              :expand-config="{
                labelField: 'name',
                expandAll: true,
                visibleMethod: expandVisibleMethod
              }"
            >
              <vxe-column type="expand" width="0">
                <template v-slot:content="{ row }">
                  <vxe-table
                    border
                    max-width="1060"
                    class="mytable-scrollbar"
                    align="center"
                    :data="row.children"
                    :show-header="false"
                    :span-method="colspanMethod"
                  >
                    <vxe-column field="pictureUrl" title="Role" :width="block === 1 || block === 3?'8%':'10%'">
                      <template v-slot="{ row }">
                        <img
                          v-if="row.pictureUrl"
                          style="width: 80px; heigjt: 100px"
                          :src="row.pictureUrl"
                          alt=""
                        />
                        <img
                          v-else
                          style="width: 80px; heigjt: 100px"
                          src="https://img.g-part.cn/prod/wss/default_null.png"
                          alt=""
                        />
                      </template>
                    </vxe-column>
                    <vxe-column field="partName" title="Address" width="20%" align="left">
                      <template v-slot="{ row }">
                        <!-- <div class="w11"> -->
                        <!-- <div class="w12"> -->
                        <div>
                        <span v-if="row.partQualityType" class="ycj">
                          {{ row.partQualityType }}</span>
                        <span v-else class="ycj">{{row.qualityType}}</span>
                        <span> {{ row.partName }}</span>
                        </div>
                        <ul class="safeguard">
                          <li >
                             <span>服务：</span>
                             <!-- <p>正品保证</p> -->
                           </li>
                           <li v-if="row.genuineGuarantee">
                             <span class="iconfont icon-a-lujing153"></span>
                             <!-- <p>正品保证</p> -->
                           </li>
                           <li v-if="row.technicalSupport">
                             <span class="iconfont icon-a-ziyuan4"></span>
                             <!-- <p>技术支持</p> -->
                           </li>
                           <li v-if="row.warrantyService">
                             <span class="iconfont icon-a-ziyuan5"></span>
                             <!-- <p>保修服务</p> -->
                           </li>
                           <li v-if="row.returnPromise">
                             <span class="iconfont icon-a-ziyuan21"></span>
                             <!-- <p>退换货承诺</p> -->
                           </li>
                        </ul>
                        <!-- </div> -->
                        <!-- <div class="w13">
                          {{ row.shipCity }}{{ row.shipStore }}
                        </div> -->
                        <!-- </div> -->
                      </template>
                    </vxe-column>
                    <vxe-column field="partNum" title="Address" width="10%">
                      <template v-slot="{ row }">
                        <span > {{ row.shipCity }}{{ row.shipStore }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="partNum" title="Address" width="10%">
                      <template v-slot="{ row }">
                        <span v-if="block !== 7">
                          <span v-show="!refundth"> {{ row.partNum}}</span>
                          <span v-show="row.type==1"> {{ row.moneybackNum}}</span>
                          <span v-show="row.type==2"> {{ row.refundNum}}</span>
                        </span>
                        <span v-else>
                          <span> {{ row.refundNum}}</span>
                        </span>
                      </template>
                    </vxe-column>
                    <vxe-column field="price" title="Address" width="12%">
                      <template v-slot="{ row }">
                        <div class="ccc">
                          {{ '￥' + row.price }}
                        </div>
                      </template>
                    </vxe-column>
                    <vxe-column field="goodsFlag" title="Address" width="10%" v-if="block !== 7">
                      <template v-slot="{ row }">
                        <span> {{ row.goodsFlag }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="10%" style="border:none;" class="w33" v-if="block === 1 || block === 3">
                      <template v-slot="{row}">
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 16">
                          <div>
                            <!-- <router-link
                              rel="opener"
                              target="_blank"
                              :to="{
                                path: '/claimSolid',
                                query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
                              }"
                              style="width:70px;color: #377CF1; display: block;margin:0 auto;"
                              >理赔处理</router-link
                            > -->
                            <div style="width: 80px;color: #fff;cursor: pointer;background:#377CF1;padding: 5px 2px;;margin:0 auto" @click="go(row,0)">理赔处理</div>
                          </div>
                          <div style="color: red">理赔中</div>
                        </section>
                        <!-- 卖家同意 无返回方式 -->
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 17 && !row.claimOrdersData.claimManageStatus">
                          <!-- <div><router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claimSolid',
                              query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
                            }"
                            style="width:70px;color: red; display: block;margin:0 auto;"
                            >理赔中</router-link
                          ></div> -->
                          <div style="color: red">理赔中</div>
                        </section>
                        <!-- 卖家同意 有返回方式 -->
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 17 && row.claimOrdersData.claimManageStatus">
                          <div>{{claimList[row.claimOrdersData.claimManageMode]}}</div>
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claimSolid',
                              query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
                            }"
                            style="width:70px;color: red; display: block;margin:0 auto;"
                            >理赔中</router-link
                          > -->
                          <div style="color: red">理赔中</div>
                        </section>
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 5 && row.claimOrdersData.claimManageStatus">
                          <div>{{claimList[row.claimOrdersData.claimManageMode]}}</div>
                          <div style="color: green">理赔完成</div>
                        </section>
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 13">
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claimSolid',
                              query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
                            }"
                            style="width:70px;color:red; display: block;margin:0 auto;"
                            >理赔拒绝</router-link
                          > -->
                          <span style="color:red">理赔拒绝</span>
                        </section>
                        <section v-if="row.claimOrdersData && row.claimOrdersData.state === 12">
                          <div>已撤销</div>
                        </section>
                      </template>
                    </vxe-column>
                    <vxe-column title="Address" width="10%" style="border:none;" class="w33" v-if="block === 7">
                      <template v-slot="{row}"> 
                        <section v-if="row.rowState.value === 16">
                          <div>
                            <!-- <router-link
                              rel="opener"
                              target="_blank"
                              :to="{
                                path: '/claimSolid',
                                query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
                              }"
                              style="width:70px;color: #377CF1; display: block;margin:0 auto;"
                              >理赔处理</router-link
                            > -->
                            <div style="width: 80px;color: #fff;cursor: pointer;background:#377CF1;padding: 5px 2px;;margin:0 auto" @click="go(row,1)">理赔处理</div>
                          </div>
                          <div style="color: red">理赔中</div>
                        </section>
                        <!-- 卖家同意 无返回方式 -->
                        <section v-if="row.rowState.value === 17 && !row.claimManageStatus">
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claimSolid',
                              query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
                            }"
                            style="width:70px;color: red; display: block;margin:0 auto;"
                            >理赔中</router-link
                          > -->
                          <div style="color: red">理赔中</div>
                        </section>
                        <!-- 卖家同意 有返回方式 -->
                        <section v-if="row.rowState.value === 17 && row.claimManageStatus">
                          <div>{{claimList[row.claimManageMode]}}</div>
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claimSolid',
                              query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
                            }"
                            style="width:70px;color: red; display: block;margin:0 auto;"
                            >理赔中</router-link
                          > -->
                          <div style="color: red">理赔中</div>
                        </section>
                        <section v-if="row.rowState.value === 5 && row.claimManageStatus">
                          <div>{{claimList[row.claimManageMode]}}</div>
                          <div style="color: green">理赔完成</div>
                        </section>
                        <section v-if="row.rowState.value === 13">
                          <!-- <router-link
                            rel="opener"
                            target="_blank"
                            :to="{
                              path: '/claimSolid',
                              query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
                            }"
                            style="width:70px;color: red; display: block;margin:0 auto;"
                            >理赔拒绝</router-link
                          > -->
                          <span style="color:red">理赔拒绝</span>
                        </section>
                        <section v-if="row.rowState.value === 12">
                          <div>已撤销</div>
                        </section>
                      </template>
                    </vxe-column>
                    <vxe-column field="rowNums" title="Address" :width="block === 1 || block === 3?'10%':'14%'">
                      <template v-slot="{ row }">
                        <div v-if="block !== 7">
                          <div v-if="!refundth">
                            <div>商品金额：{{ '￥' + row.money }}</div>
                            <div>
                            实付金额：<span
                              style="color: red; font-weight: 700"
                              >{{ '￥' + row.payMoney }}</span
                            >
                          </div>
                          <!-- <div>含运费：</div> -->
                          </div>
                          <div v-else>
                            <div v-show="row.type==2">退货金额<span style="color: red; font-weight: 700">{{ '￥' + row.afterSaleAmount }}</span></div>
                            <div v-show="row.type==1">退款金额<span style="color: red; font-weight: 700">{{ '￥' + row.afterSaleAmount }}</span></div>
                          </div>
                        </div>
                        <div v-else>
                          <div>理赔金额：{{ '￥' + row.refundAmount }}</div>
                        </div>
                      </template>
                    </vxe-column>
                    <vxe-column field="rowNums" title="Address" :width="block === 1 || block === 3?'10%':'14%'">
                      <template v-slot="{ row }">
                        <div
                          style="margin:0 auto"
                          class="fh"
                          v-if="row.state == 2&&!refundth&&tenantType == 3"
                          @click="deliver(row)"
                        >发货</div>
                        <!-- <div
                          class="fh"
                          v-if="row.state == 9"
                          style="margin-top: 10px"
                        >
                          退款处理
                        </div> -->
                          <!-- target="_blank"
                          rel="opener" -->
                        <router-link
                          :to="{
                            path: '/refunddispose',
                            query: { drawback: row.refundId }
                          }"
                          class="fh"
                          v-if="row.state == 9 &&!refundth"
                          style="display: inline-block; margin-top: 10px"
                          >退款处理</router-link
                        >
                        <router-link
                          :to="{
                            path: '/salesreturn',
                            query: { drawback: row.refundId, refundType: row.refundType }
                          }"
                          class="fh"
                          v-if="row.state == 10 &&!refundth"
                          style="display: inline-block; margin-top: 10px"
                          >退货处理</router-link
                        >
                        <!-- <div  v-if="row.state == 9" @click="refundProcessing(row)" style="display: inline-block; margin-top: 10px"   class="fh" >退款处理</div> -->
                          <!-- target="_blank"
                          rel="opener" -->
                          <!-- 卖家发起退款isSellerRefunded  ==1 -->
                        <router-link
                          v-if="block === 6  && row.isSellerRefunded == 1"
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/saleshandlereturn',
                            query: { drawback: row.id, }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                        <!-- 买家发起退款isSellerRefunded  ==0 -->
                          <router-link
                          v-if="block === 6  && row.isSellerRefunded == 0 && row.refundType == 1"
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/refunddispose',
                            query: { drawback: row.id, }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                          <router-link
                          v-if="(block === 6  && row.isSellerRefunded == 0 && row.refundType == 2) || (block === 6  && row.isSellerRefunded == 0 && row.refundType == 3)"
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/salesreturn',
                            query: { drawback: row.refundId,refundType: row.refundType }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                        <!-- <router-link
                           v-if="block === 7 "
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/orderDetails',
                            query: { id: row.ordersChangeCode,orderId: row.originalOrdersData.ordersId ,refundId:row.refundId }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        > -->
                        <div v-if="block === 7 " style="width:70px;color: #377CF1;cursor:pointer;margin:0 auto;" @click="go(row,2)">订单详情</div>
                        <router-link
                           v-if="block !== 6 && block !== 7 "
                           rel="opener"
                           target="_blank"
                          :to="{
                            path: '/orderDetails',
                            query: { id: row.ordersCode,orderId: row.id ,refundId:row.refundId }
                          }"
                          style="width:70px;color: #0074ff; display: block;margin:0 auto;"
                          >订单详情</router-link
                        >
                        <!-- <router-link
                          :to="{
                            path: '/saleshandlereturn',
                            query: { id: row.ordersCode,orderId: row.id }
                          }"
                           v-if="row.state == 2&!refundth"
                          style="color: #0074ff; display: block"
                          >发起退款</router-link
                        > -->
                         <div
                          style="color: #0074ff; display: block; cursor: pointer;"
                          v-if="row.state == 2&!refundth"
                          v-has="'WSS-2001-sellerRefund'"
                          @click="sponsortk(row)"
                        >发起退款</div>
                        <!-- <div v-if="row.state == 3">还剩2天收货</div> -->
                      </template>
                    </vxe-column>
                  </vxe-table>
                </template>
              </vxe-column>
              <vxe-column field="code" title="商品信息" :width="block === 1 || block === 3?'28%':'30%'">
                <template v-slot="{ row }">

                  <div class="rowBox">
                    <span style="font-weight:700;font-size:12px;text-align: left;">订单号： {{ row.code }}</span>
                    <span :style="[{color: row.pushStatus == 2 ? '#F62B4E' : '#47C460'}]" class="iconfont icon-zhifeiji_fabu pos"></span>
                  </div>
                  <div style="text-align: left;margin-left:25px">
                    <span style="font-size:12px;margin-right:10px"> {{ row.createShopName }}</span>
                    <!-- {{row}} -->
                    <xiaopei :oppositeTenantId="row.tenantId" :orderId="row.id" v-show="block !== 6">
                        <i class="iconfont icon-a-lujing162"></i>
                    </xiaopei>
                  </div>
                </template>
              </vxe-column>
              <vxe-column field="发货地" title="发货地" width="10%">
              </vxe-column>
              <vxe-column field="数量" title="数量" width="10%"> 
              </vxe-column>
              <vxe-column field="单价" title="单价(元)" width="12%">
                <template v-slot="{ row }">
                  <span style="font-size:12px;">{{row.createTime}}</span>
                </template>
              </vxe-column>
              <vxe-column
                field="商品状态"
                title="商品状态"
                width="10%"
                v-if="block !== 7"
              ></vxe-column>
              <vxe-column
                title="理赔申请"
                width="10%"
                v-if="block === 1 || block === 3 || block === 7"
              >
              </vxe-column>
              <vxe-column
                field="state.name"
                title="收款信息"
                :width="block === 1 || block === 3?'10%':'14%'"
                show-overflow="tooltip"
              >
                <template v-slot="{ row }">
                    <span v-if="refundth">{{row.cancelReason}}</span>
                    <span v-else>{{row.state.name}}</span>
                </template>
              </vxe-column>
              <vxe-column title="交易操作" :width="block === 1 || block === 3?'10%':'14%'">
                <template v-slot="{ row }">
                  <a
                  v-if="!refundth"
                    :href="
                      `${publicPath}wss-order/myWssOrder/simpleExportOrder?code=${row.code}&access_token=${token}`
                    "
                    class="iconfont icon-a-lujing296"
                    style="font-size: 14px"
                    v-has="'WSS-2001-export'"
                  > <i>导出</i></a>
                    <span v-if="(row.state.value === 3&&!refundth) || (row.state.value === 5&&!refundth)" style="margin-left:20px;" @click="soldPrint(row)" title="打印" class="iconfont icon-a-2" v-has="'WSS-2001-printer'"><i>打印</i> </span>
                </template>
              </vxe-column>
            </vxe-table>
          </div>
        </div>
                <div  style="display: flex; justify-content: right;padding-right: 17px;">
              <vxe-pager
                background
                :current-page.sync="page.current"
                :page-size.sync="page.size"
                @page-change="pageChange"
                :total="totalResult"
                :page-sizes="[30]"
                :layouts="[
                  'PrevJump',
                  'PrevPage',
                  'JumpNumber',
                  'NextPage',
                  'NextJump',
                  'Sizes',
                  'FullJump',
                  'Total'
                ]"
              >      
              </vxe-pager>
              <span  
              style="
         height: 31px;
        padding: 7px 10px;
        border: 1px solid rgb(220, 222, 226);
        border-radius: 4px;
        margin-top: 8px;
        line-height: 13px;
            ">30条/页</span>
            </div>
      </div>
      <!-- <div v-if="block === 5" class="mind">
          <Spin fix v-if="show">
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
        <vxe-table
          ref="xTable"
          border="inner"
          auto-resize
          :data="tableData"
          class="mytable-style"
          :cell-style="cellStyle"
          :expand-config="{
            labelField: 'name',
            expandAll: true,
            visibleMethod: expandVisibleMethod
          }"
        >
          <vxe-column type="expand" width="0">
            <template v-slot:content="{ row }">
              <vxe-table
                border="inner"
                max-width="1200"
                class="mytable-scrollbar"
                :data="row.children"
                :show-header="false"
                :span-method="colspanMethod"
              >
                <vxe-column field="pictureUrl" title="Role" width="100">
                  <template v-slot="{ row }">
                       <img
                        v-if="row.pictureUrl"
                        style="width: 80px; heigjt: 100px"
                        :src="row.pictureUrl"
                        alt=""
                      />
                      <img
                        v-else
                        style="width: 80px; heigjt: 100px"
                        src="@/assets/images/shoppingCart/2.jpg"
                        alt=""
                      />
                  </template> </vxe-column
                >>
                <vxe-column field="partName" title="Address" width="400">
                  <template v-slot="{ row }">
                    <span v-if="row.partQualityType" class="ycj"> {{ row.partQualityType }}</span>
                    <span> {{ row.partName }}</span>
                  </template>
                </vxe-column>
                <vxe-column field="partNum" title="Address" width="100">
                  <template v-slot="{ row }">
                    <span> {{ row.partNum }}</span>
                  </template>
                </vxe-column>
                <vxe-column field="price" title="Address" width="100">
                  <template v-slot="{ row }">
                    <div class="ccc">
                      {{ '￥' + row.price }}</div
                    >
                  </template>
                </vxe-column>
                <vxe-column field="goodsFlag" title="Address" width="100">
                  <template v-slot="{ row }">
                    <span> {{ row.goodsFlag }}</span>
                  </template>
                </vxe-column>
                <vxe-column field="rowNums" title="Address" width="200">
                  <template v-slot="{ row }">
                    <div>商品金额：{{ '￥' + row.money }}</div>
                    <div>
                      实付金额：<span style="color: red; font-weight: 700">{{
                        '￥' + row.payMoney
                      }}</span>
                    </div>
                  </template>
                </vxe-column>
                <vxe-column field="rowNums" title="Address" width="200">
                  <template v-slot="{ row }">
                    <div class="fh" v-if="row.state == 2">发货</div>
                    <div
                      class="fh"
                      v-if="row.state == '退款处理'"
                      style="margin-top: 10px"
                    >
                      退款处理
                    </div>
                    <router-link
                    rel="opener"
                      target="_blank"
                      :to="{
                        path: '/orderDetails',
                        query: { id: row.ordersCode }
                      }"
                      style="color: #0074ff"
                      >订单详情</router-link
                    >
                    <div>还剩2天收获</div>
                  </template>
                </vxe-column>
              </vxe-table>
            </template>
          </vxe-column>
          <vxe-column field="code" title="商品信息" width="500">
            <template v-slot="{ row }">
              <span>订单号： {{ row.code }}</span>
              <span> {{ row.buyShopName }}</span>
              <span class="iconfont icon-shangcheng"></span>
              <span class="mendian">{{ row.userName }}</span>
              <span class="iconfont icon-a-lujing162" @click="go('im')"></span>
            </template>
          </vxe-column>
          <vxe-column field="数量" title="数量" width="100"> </vxe-column>
          <vxe-column field="单价" title="单价" width="100"> </vxe-column>
          <vxe-column
            field="商品状态"
            title="商品状态"
            width="100"
          ></vxe-column>
          <vxe-column field="state.name" title="收款信息" width="200"></vxe-column>
          <vxe-column title="交易操作" width="200">
            <template v-slot="{ row }">
              <a
                :href="`${publicPath}wss-order/myWssOrder/simpleExportOrder?code=${row.code}&access_token=${token}`"
                class="iconfont icon-a-lujing296"
                style="font-size: 12px"
              ></a>
            </template>
          </vxe-column>
        </vxe-table>
      </div> -->
      <!-- <vxe-pager
        background
        :current-page.sync="page.current"
        :page-size.sync="page.size"
        @page-change="pageChange"
        :total="totalResult"
        :page-sizes="[ 30]"
        :layouts="[
          'PrevJump',
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'NextJump',
          'Sizes',
          'FullJump',
          'Total'
        ]"
      >

      </vxe-pager> -->

      <!-- 物流信息 -->
      <Modal
        v-model="logistics"
        title="物流信息"
        :mask-closable="false"
        :closable="false"
        footer-hide
        >
       <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
           <FormItem label="配送方式:" prop="transportType">
               <Select v-model="formValidate.transportType">
                   <Option v-for="item in deliverylist" :key="item.id" :value="item.id">{{item.name}}</Option>
               </Select>
           </FormItem>
           <FormItem label="运输公司:" prop="transportCompany">
               <Input v-model="formValidate.transportCompany" type="textarea" :autosize="{minRows: 2, maxRows: 3}" maxlength="50" show-word-limit></Input>
           </FormItem>
           <FormItem label="单号:" prop="logisticsCode">
               <Input v-model="formValidate.logisticsCode" type="textarea" :autosize="{minRows: 2,maxRows: 3}" maxlength="50" show-word-limit></Input>
           </FormItem>
           <FormItem label="联系手机:" prop="deliverPhone">
               <Input v-model="formValidate.deliverPhone"></Input>
           </FormItem>
           <FormItem label="预计到货时间:" prop="arrivalTime">
              <DatePicker type="date" @on-change="time1" v-model="formValidate.arrivalTime" :options="options3"></DatePicker>
           </FormItem>
           <FormItem label="发货备注" prop="remark">
               <Input v-model="formValidate.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" maxlength="100" show-word-limit></Input>
           </FormItem>
           <FormItem>
               <Button type="error" :loading="dogood" class="btn mr50" @click="handleSubmit('formValidate')">确定发货</Button>
               <Button type="error" class="btn" @click="handleReset('formValidate')" style="margin-left:8px">取消</Button>
           </FormItem>
       </Form>
    </Modal>
    </div>
        <soldPrint ref="printZF" style="display: none"></soldPrint>
  </div>
</template>

<script>
import urlObj from '@/config/env.js'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import xiaopei from '@/views/xiaopei/index.vue'
import { getDate } from '@/libs/tools.js'
import { storeName, getSalesOrder, orderDelivery ,getSalesReturn,getshipments} from '@/api/business/sold.js'
import { cliamList } from '@/api/myweb/cliam'
import {
  buyshopstate,
  applyForRefund
} from '@/api/business/bought.js'
// import { awaken } from '@/api/xiaopei/shout.js'
import soldPrint from './components/soldPrint.vue'
export default {
  // mixins: [awaken],
  components: {
    // headerTop
    xiaopei,
    soldPrint
  },
  data() {
    return {
      claim: {
        code:'',
        part:'',
        userNames:'',
        state:''
      }, //理赔参数
      claimstateList: [
        { value: '0',name:'所有' },
        { value: '1',name:'理赔中' },
        { value: '2',name:'理赔完成' },
        { value: '3',name:'理赔拒绝' },
        { value: '4',name:'已撤销' }
      ],
      claimReviceList: ['','收到原货','收到换货','收到退货','已经销毁'],
      claimList: ['','原货退还','换货处理','退货处理','原物销毁'],
      refundth:false, //退款退货
      companytk:[], //退款店铺名称
      dogood:false, // 转圈
        // 表单
      formValidate: {
          transportType: '', // 方式
          transportCompany: '', // 运输公司
          logisticsCode: '', // 单号
          deliverPhone: '', // 联系手机
          arrivalTime: '', //到货时间
          remark : '', //备注
      },
      // 规则
      ruleValidate: {
        transportType: [
            { required: true, message: '请选择配送方式', trigger: 'change' }
        ],
        transportCompany: [
            { required: true, message: '请输入运输公司', trigger: 'blur' },
        ],
        logisticsCode: [
            { required: true, message: '请输入单号', trigger: 'blur' }
        ],
        deliverPhone:[
            {
            pattern: /^((13[0-9])|(14[5-9])|(15[0-3,5-9])|(16[5-7])|(17[0-9])|(18[0-9])|19([0,1,3,5,8,9]))\d{8}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
      },
      logistics: false, // 物流信息
      deliverylist:[
       {
        id:'0',
        name:'物流'
       },
       {
        id:'1',
        name:'快递'
       },
       {
        id:'2',
        name:'自配'
       },
       {
        id:'3',
        name:'自提'
       }
      ], // 配送方式
      // 时间规则
      options3: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      salesfrom:{
        code:'',
        partMsg:'',
        userNames:'',
        model1:''
      },
      value3:'',
      orderStatusth:[
        {
          value: 1,
          name: '已退款'
        },
         {
          value: 2,
          name: '已退货'
        },
      ],
      shipments:'', // 发货
      tenantType: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
        .tenantType,
      // 下面是何龙写的
      show: false,
      c: '',
      token: Cookies.get(TOKEN_KEY),
      // token: JSON.parse(window.sessionStorage.getItem('vuex')).user.token,
      publicPath: urlObj.wss,
      deliverState: true, // 发货状态
      userName: '', // 店铺名称
      code: '',
      partMsg: '',
      remoteloading: false,
      userNames: '',
      block: 1,
      model1: '',
      model2: '', // 订单来源
      time: [],
      company: [], // 店铺查询的数据
      tops: [
        {
          value: 1,
          name: '所有订单'
        },
        {
          value: 2,
          name: '待发货'
        },
        {
          value: 3,
          name: '交易完成'
        },
        {
          value: 4,
          name: '退款申请'
        },
        {
          value: 5,
          name: '退货申请'
        },
        {
          value: 6,
          name: '退款/退货'
        },
        {
          value: 7,
          name: '理赔申请'
        }
      ],
      orderStatus: [
        {
          value: -1,
          name: '全部'
        },
        {
          value: 1,
          name: '待付款'
        },
        {
          value: 2,
          name: '待发货'
        },
        {
          value: 3,
          name: '待收货'
        },
        {
          value: 5,
          name: '交易完成'
        },
        {
          value: 6,
          name: '交易取消'
        },
        {
          value: 11,
          name: '交易关闭'
        }
      ],
      orderSource:[
        {
          value: -1,
          name: '全部'
        },
        {
          value: 1,
          name: '极联web'
        },
        {
          value: 2,
          name: '线下开单'
        },
        {
          value: 3,
          name: '极联web-询价单'
        },
      ],
      tableData: [],

      page: {
        current: 1,
        size: 30
      },
      totalResult: 0
    }
  },
  created() {
    this.tableList(1)
    this.getOne()
    this.buyshopstate()
  },
  methods: {
    go(row,type) {
      let routeData
      if(type === 0){
        // 理赔受理
        routeData = this.$router.resolve({
          name: 'claimSolid',
          query: { ordersId: row.rowId, ordersDetailId:row.claimOrdersData.ordersDetailId,code:row.claimOrdersData.ordersCode,type:1 }
        })
      }else if(type === 1){
        // 理赔受理
        routeData = this.$router.resolve({
          name: 'claimSolid',
          query: { ordersId: row.originalOrdersData.ordersId, ordersDetailId:row.id,code:row.ordersCode,type:1 }
        })                       
      }else{
        // 跳转详情
        routeData = this.$router.resolve({
          name: 'orderDetails',
          query: { id: row.ordersChangeCode,orderId: row.originalOrdersData.ordersId ,refundId:row.refundId }
        }) 
      }
      window.open(routeData.href,'_blank')
    },
    // 发起退款
   async sponsortk(row){
      console.log(row);
      console.log('发起退款');
       let res = await applyForRefund(row.id)
       if(res.status){
          this.$router.push({
        path:'/saleshandlereturn',
        query:{details: row.id}
      })
      }
    },
     // 店铺名称
    async buyshopstate(){
      const res=await buyshopstate({
        shopName:'',
        state:2
      })
      if(res.status){
        this.companytk=res.data.list
      }
    },
     // 到货时间
    time1(a){
      console.log(a);
    },
    // 确定
    handleSubmit (name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.dogood=true
            let data=JSON.parse(JSON.stringify(this.formValidate))
            if (data.arrivalTime) {
              data.arrivalTime = getDate(
              data.arrivalTime
             )
            }
            data.orderId=this.shipments
            console.log(data);
            const res = await getshipments(data)
            console.log(res);
            this.dogood=false
            if(res.status){
              this.tableList(2)
              this.$Message.success('已发货')
              this.logistics=false
              this.$refs[name].resetFields();
            }
        } else {
          this.$Message.destroy()
          this.$Message.error('请检查表单字段!');
        }
      })  
    },
    // 取消
    handleReset (name) {
      this.$refs[name].resetFields();
      this.logistics=false
    },
    // 切换
    all(a) {
      this.block = a
      if(a==1) {
        this.code = ''
        this.partMsg = ''
        this.userNames = ''
        this.model1 = ''
        this.model2 = ''
      
      }
      this.tableList(2)
    },
    // 搜索
    async search() {
      this.tableList(2)
    },
    searchtk(){
      console.log(this.block);
      this.tableList(2)
    },
    // 退货/退款的 (店铺名称)
    getOnes6(val) {
        if(val){
       this.salesfrom.userNames = val
      }
      // this.salesfrom.userNames = val
    },

    // 所有订单数据
    async tableList(num) {
      this.show = true
      let data1={
        code: this.salesfrom.code,
        partMsg: this.salesfrom.partMsg,
        tenantId:this.salesfrom.userNames,
        businessState:2,
        status:this.salesfrom.model1,
        current: this.page.current,
        size: this.page.size,
      }
      let params = {
        current: this.page.current,
        size: this.page.size,
      }
      let data = {
        code: this.code,
        partMsg: this.partMsg,
        startTime: this.time[0] == undefined || this.time[0] == '' ? '' : this.time[0] + ' 00:00:00',
        endTime: this.time[1] == undefined || this.time[1] == '' ? '' : this.time[1] + ' 23:59:59',
        shopId: this.userNames
      }
      switch (this.block) {
        case 1:
          data.state = [this.model1]
          break
        case 2:
          data.state = [2]
          break
        case 3:
          data.state = [5]
          break
        case 4:
          data.state = [9]
          break
        case 5:
          data.state = [10]
          break
      }
      if(this.block==6){
        const res=await getSalesReturn(data1)
        console.log(res);
        this.show = false
         if (res.status) {
        this.show = false
        this.refundth = true
        // this.page.current = res.data.current
        // this.page.size = res.data.size
        this.totalResult = res.data.total
        this.tableData = res.data.records
        if (num === 2) {
          this.$refs.xTable.reloadData(this.tableData)
        }
        this.tableData.filter(el => {
          let c = el.money
          let a = el.payMoney
          let state = el.state.value
          let ids = el.id
          let b = el.modifyMoney
          let r = el.refundId
          let s = el.refundType
          el.rowNum = el.children.length
          let h=el.afterSaleAmount
          let d = el.isSellerRefunded
          el.children.filter(el => {
            el.isSellerRefunded = d // 判断买卖双方哪家发起的
            el.rowNums = 1
            el.money = c
            el.payMoney = a
            el.state = state
            el.id = ids
            el.refundType = s
            el.modifyMoney = b
            el.refundId = r
            el.afterSaleAmount=h
          })
        })
      } 
      }else if(this.block === 7) {
        console.log('--------------');
        this.show = false
        let obj = {
          ordersCode: this.claim.code,
          partMsg:this.claim.part,
          tenantId:this.claim.userNames,
          businessState: 2
        }
        switch (this.claim.state){
          case ''|| '0' : break;
          case '1': obj.state = [16,17]; break;
          case '2': obj.state = [5]; break;
          case '3': obj.state = [12]; break;
          case '4': obj.state = [13]; break;
        }
        let res = await cliamList(obj,this.page)
        if(res.status) {
          this.show = false
          this.totalResult = res.data.total
          this.tableData = res.data.records
          if (num === 2) {
            this.$refs.xTable.reloadData(this.tableData)
          }
          this.tableData.forEach(item => {
            item.children.forEach(i => {
              i.rowId = item.id
              i.rowState = item.state
              i.rowNums = 1
            })
          })
        }  
      }
      else{
        let storeSource = JSON.parse(JSON.stringify(this.model2 == '' ? '-1' : this.model2))
        let storeState = JSON.parse(JSON.stringify(data.state == '' ? [-1] : data.state))
        data.source = storeSource 
        data.state = storeState
        console.log(data);
        let res = await getSalesOrder(params, {...data,...params})
         if (res.status) {
        this.show = false
        this.refundth = false
        // this.page.current = res.data.current
        // this.page.size = res.data.size
        this.totalResult = res.data.total
        this.tableData = res.data.records
        if (num === 2) {
          this.$refs.xTable.reloadData(this.tableData)
        }
        this.tableData.filter(el => {
          let c = el.money
          let a = el.payMoney
          let state = el.state.value
          let ids = el.id
          let b = el.modifyMoney
          let s = el.refundType
          let r = el.refundId
          let rowId = el.id
          const rowState = el.state
          el.rowNum = el.children.length
          el.children.filter(el => {
            el.rowNums = 1
            el.money = c
            el.payMoney = a
            el.state = state
            el.id = ids
            el.modifyMoney = b
            el.refundType = s
            el.refundId = r
            el.rowId = rowId
            el.rowState = rowState
          })
        })
      } else {
        this.show = false
      }
      }
     console.log(this.tableData );
    },
    reset(){
        this.salesfrom = {
        code:'',
        partMsg:'',
        userNames:'',
        model1:'',
        // model3:''
      } 
      this.page = {
        current: 1,
        size: 30
      },
      this.value3 = ''
      this.code = ''
      this.partMsg = ''
      this.userNames = ''
      this.model1 = ''
      // this.model3 = ''
      this.model2 = ''
      this.time = ''
      this.tableList(2)
    },
    // 订单状态选择
    statusSelection(value) {
      this.model1 = value
    },
    // 订单来源
    sourceSelection(value) {
      this.model2 = value
    },
     // 订单状态选择
    statusSelectiontk(value) {
      this.salesfrom.model1 = value
    },

    // 表格合并
    colspanMethod({ row, _rowIndex, column, visibleData }) {
      // console.log(row, _rowIndex, column, visibleData);
      let fields = ['rowNums']
      // console.log(fields);
      let cellValue = row[column.property]
      // console.log(cellValue);
      if (cellValue && fields.includes(column.property)) {
        let prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        // console.log(prevRow, nextRow);
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
      // console.log(_rowIndex);
    //   if (_rowIndex % 2 === 0) {
    //   if (_columnIndex === 2) {
    //   return { rowspan: 1, colspan: 2 }
    //   } else if (_columnIndex === 3) {
    //    return { rowspan: 0, colspan: 0 }
    //    }
    //  }
    },

    // 时间显示的
    colspanMethod1 ({ _rowIndex, _columnIndex }) {
      //  if (_rowIndex % 2 === 0||_rowIndex % 2 === 1) {
      //     if (_columnIndex === 2) {
      //         return { rowspan: 1, colspan: 2 }
      //     } else if (_columnIndex === 3) {
      //       return { rowspan: 0, colspan: 0 }
      //     }
      //   }
      },
    // 时间的change事件
    changeCompanyDate(date) {
      this.time = date
      console.log(date);
    },

    // 店铺数据
    async getOne() {
      this.remoteloading = true
      let res = await storeName()
      if (res.status) {
        this.company = res.data.list
        this.remoteloading = false
      }
    },
    getOnes(val) {
      console.log(typeof val);
                  if(val){
       this.userNames = val
      }
      // this.userNames = val
    },
    // 发货
     deliver(row) {
      this.logistics=true
      this.shipments=row.id
      // let params = {}
      // params.orderId = row.id
      // let res = await orderDelivery(params)
      //   if (res.status) {
      //     this.tableList(2)
      //     this.$Message.success('已发货')
      //   }
    
    },
    
    // 取消表格的下拉图标
    expandVisibleMethod({ row }) {
      return false
    },

    // 表头颜色
    cellStyle({ rowIndex }) {
      if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(rowIndex)) {
        return {
          backgroundColor: '#ffffff'
        }
      }
    },
    // 分页事件
    pageChange({ currentPage, pageSize }) {
      // currentPage  页数
      // pageSize 当前页的条数
      this.page.current = currentPage
      this.page.size = pageSize
      this.tableList(2)
    },
    
    // 退款处理
    // refundProcessing(row){
    //   // console.log(row);
    //   if(row.refundId != null){
    //     const { href } = this.$router.resolve({
    //     path: '/refunddispose',
    //     query: { drawback: row.refundId}
    //   });
    //   window.open(href, '_blank', console.log(href));
    //   }else{

    //   }
    // }
    soldPrint(row){
      // this.$refs.printZF.jjj()
      this.$refs.printZF.jjj(row.id)
    }
  }
}

</script>

<style lang="less" scoped>
.box {
  width: 95%;
  max-height: 728px;
  overflow-y: scroll;
  margin: 0 auto;
  .top {
    text-align: center;
    margin: 0 auto;
    height: 100%;
    width: 100%;
    display: flex;
    span {
      cursor: pointer;
      flex: 1;
      font-weight: 700;
      font-size: 16px;
      text-align: center;
    }
    .color {
      color: rgb(217, 0, 27);
    }
  }

  .mind {
    background-color: #ffffff;
    margin-top: 20px;
    .mind-one-top {
      margin-top:20px ;
      // height:50px;
      span {
        display: inline-block;
        padding-top: 20px;
      }
    }
    .table {
      width: 98%;
      margin: 0 auto;
      .mendian {
        display: inline-block;
        margin-right: 5px;
      }
      .icon-a-lujing162 {
        color: rgb(18, 150, 219);
        font-size: 16px;
      }
      .one {
        width: 400px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img {
          width: 150px;
          height: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .img-rigth {
          margin-top: 20px;
          width: 300px;
          height: 100px;

          .tow {
            margin-top: 30px;
            span {
              margin: 0 3px;
            }
          }
        }
      }
    }
  }
}
.god {
  color: #377CF1;
  display: inline-block;
  width: 64px;
  height: 100%;
  display: inline-block;
  border-bottom: 1px solid #377CF1;
}
.god:hover{
   transition: border-bottom .5s;
   border-bottom: 4px solid #377CF1;
}
.search {
  margin-left: 20px;
  display: inline-block;
  width: 80px;
  height: 30px;
  background: #377CF1;
  border-radius: 2px;
  color: white;
  text-align: center;
  line-height: 30px;
}
.reset{
  background: #FFFFFF;
  border: 1px solid #377CF1;  
  color: #377CF1;
}
.danjia {
  font-weight: 700;
}
.icon-shangcheng {
  margin-left: 20px;
  margin-right: 5px;
  color: red;
}
.icon-a-lujing153 {
  color: #47c460;
}
.icon-a-ziyuan5 {
  color: #ff8a24;
}
.icon-a-ziyuan4 {
  color: #24b4ff;
}
 .icon-a-ziyuan21 {
   color: #ff3e3e;
}
.safeguard{
  display: flex;
  justify-content: left;
  align-items: center;
  // margin-top: 14px;
  li{
    display: flex;
    justify-content: space-around;
    margin-right: 5px;
  }
}
.fahuo {
  width: 80px;
  height: 30px;
  line-height: 30px;
  margin-left: 30px;
  margin-top: 10px;
  background: #e90d0d;
  opacity: 1;
  border-radius: 2px;
  color: white;
}
.fahuos {
  width: 80px;
  background: #e90d0d;
  font-weight: 700;
}
// .dsadas {
//   margin-top: 70px;
//   border-bottom: 1px solid rgb(232, 234, 236);
//   padding: 0 !important;
//   margin: 0 !important;
//   width: 100%;
//   height: 100px;
//   color: red;
// }
.icon-a-lujing296 {
  color: #A8A8A8;
  cursor: pointer;
  i{
    color: #505050;
    padding-left: 2px;
  }
}
.icon-a-2 {
  font-size: 13px;
  color: #A8A8A8;
  cursor: pointer;
    i{
    color: #505050;
    padding-left: 3px;
  }
}
.ycj {
  background: #47c460;
  border-radius: 2px;
  line-height: 16px;
  color: #ffffff;
  opacity: 1;
  text-align: center;
  margin-right: 4px;
}
.fh {
  cursor: pointer;
  width: 80px;
  height: 30px;
  background: #377CF1;
  opacity: 1;
  border-radius: 2px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
}

.btn{
  width: 100px;
  height: 35px;
}
.mr50{
  margin-right: 50px;
}
/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  //  display: none;
}
.ccc {
  font-weight: 700;
  line-height: 0px;
}

/deep/ .vxe-table--render-default.border--full .vxe-body--column{
      background-image:none;
      border: 1px solid #ccc;
      border-left:none ;
      border-top: none;
      background-repeat:no-repeat;
      background-size:none;
      background-position:none
}
/deep/ .vxe-table--render-default.border--full .vxe-body--column:nth-child(-n+4){
  border-right: none;
}
/deep/  .vxe-body--column:last-child{
  border: none;
}
.rowBox{
height:100%;
width:100%;
text-align: left;
margin-left:25px;
position: relative;
padding: 0;
}
.pos{
  position: absolute;
  left: -25px;
  top: 10px;
}
.select{
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding: 15px 9px;
  // border: 1px solid #ccc;
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  box-shadow:2px 2px 10px 3px rgba(104, 104, 104, 0.1);
  opacity: 1;
  border-radius: 0px;
}
// /deep/.vxe-body--expanded-cell{
//   max-height: 338px;
//   overflow-y: auto;
// }
/*滚动条整体粗细样式*/
// /deep/::-webkit-scrollbar {
//     /*高宽分别对应横竖滚动条的尺寸*/
//     width: 8px;
//     height: 8px;
// }

// /*滚动条里面小方块*/
// /deep/::-webkit-scrollbar-thumb {
//     // border-radius: 10px !important;
//     box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.2) !important;
//     /* 颜色 */
//     /* background:#b6b6b6!important; */
//     /* 线性渐变背景 */
//     background-image: #f8f1f1;
// }

// /*滚动条轨道*/
// /deep/::-webkit-scrollbar-track {
//     // border-radius: 10px !important;
//     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
//     background: #EDEDED !important;
// }
.w11{
  display: flex;
  justify-content: space-between;
  .w12{
   width: 60% ;
    max-width:250px;
  }
}
/deep/.vxe-pager--sizes{
  display: none;
}
</style>
